import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=b23f6de8"
import script from "./SwiperItem.vue?vue&type=script&lang=js"
export * from "./SwiperItem.vue?vue&type=script&lang=js"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=b23f6de8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports